import React, { useEffect, useState } from 'react';

import DimpleDivider from '@tds/core-dimple-divider';
import Spinner from '@tds/core-spinner';

import { TopBarWrapper } from './css';

import request from '../../../../utils/request';

import Add from './components/add';
import Filter from './components/filter';
import Block from './components/block';

const Dealership = () => {
  const [apiData, setApiData] = useState();
  const [filterString, setFilterString] = useState();

  const fetchData = async () => {
    try {
      const result = await request.get('/dealerships');

      if (result && result.status === 200) {
        setApiData(result.data.rows);
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
    <div className='layout-container'>
      <DimpleDivider />
      {!apiData && <Spinner spinning label="Loading data..." />}
      {apiData && (
        <>
          <TopBarWrapper>
            <Add fetchData={fetchData} />
            <Filter
              filterString={filterString}
              setFilterString={setFilterString}
            />
          </TopBarWrapper>
          <DimpleDivider />
          <Block
            data={apiData}
            filterString={filterString}
            fetchData={fetchData}
          />
        </>
      )}
      </div>
    </>
  );
};

export default Dealership;
